import React from "react";
import { Link } from "react-router-dom";
import { FaHome, FaSearch } from "react-icons/fa";
import "./NotFound.css";
import logo from "../../asset/images/kkm-logo.png";

const NotFound = () => {
    return (
        <div className="not-found-container">
            <div className="not-found-content">
                <div className="not-found-logo-container">
                    <img src={logo} alt="KKM Logo" className="not-found-logo" />
                </div>
                <h1 className="not-found-title">404</h1>
                <h2 className="not-found-subtitle">Oops! Page Not Found</h2>
                <p className="not-found-text">
                    The page you are looking for might have been removed, had its name
                    changed, or is temporarily unavailable.
                </p>
                <div className="not-found-actions">
                    <Link to="/" className="not-found-button home-button">
                        <FaHome className="button-icon" /> Back to Home
                    </Link>
                    {/* <Link to="/search" className="not-found-button search-button">
                        <FaSearch className="button-icon" /> Search Profiles
                    </Link> */}
                </div>
            </div>
            <div className="not-found-background">
                <div className="blob blob-1"></div>
                <div className="blob blob-2"></div>
                <div className="blob blob-3"></div>
            </div>
        </div>
    );
};

export default NotFound;
